import React from 'react';
import { Select } from '@windmill/react-ui';
// import Select from 'react-select';
const SelectQuote = ({ t,setSelecttedQuote, name, label, quotes,selecttedQuote }) => {
  // const options = users?.map((user) => ({
  //   value: user.id,
  //   label: user.name,
  // }));


  
  console.log('type state', typeof selecttedQuote)
  console.log('quote rrrr', selecttedQuote)


  
  return (
    <>
      <Select
    
        onChange={(e) => setSelecttedQuote(e.target.value)}
        className="border h-8 text-xs focus:outline-none block w-full bg-gray-100 dark:bg-white border-transparent focus:bg-white"
      
        value={selecttedQuote}
      >
        <option value="" defaultValue hidden>
          {t('Quote request')}
        </option>
        {quotes?.map((quote) => (
          <option key={quote.id} value={quote.id} selected={quote.id===selecttedQuote}>
            # {quote.id} - {quote.first_name} {quote.last_name} 
          </option>
        ))}
      </Select>
    </>
  );
};

export default SelectQuote;
